import React, { useContext } from 'react';
import { ThemeProvider } from 'styled-components';
import { TypographyGlobalStyles } from '~typography';
import ThemeModeContext from './context/ThemeModeContext';
import GlobalStyle from './GlobalStyle';
import baselineTheme from '../styles/baselineTheme';

var BaselineThemeMode = function BaselineThemeMode(_ref) {
  var theme = _ref.theme,
      children = _ref.children;

  var _useContext = useContext(ThemeModeContext),
      themeMode = _useContext.themeMode;

  var currentTheme = theme[themeMode];
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: currentTheme
  }, /*#__PURE__*/React.createElement(GlobalStyle, {
    theme: currentTheme
  }), /*#__PURE__*/React.createElement(TypographyGlobalStyles, null), children);
};

BaselineThemeMode.defaultProps = {
  theme: baselineTheme
};
export default BaselineThemeMode;